import React from 'react';
import { css } from '@emotion/css';
import { Button, FlexBox } from '@cimpress/react-components';
import IconArrowButtonRight from '@cimpress-technology/react-streamline-icons/lib/IconArrowButtonRight';
import IconNavigationMenuVertical from '@cimpress-technology/react-streamline-icons/lib/IconNavigationMenuVertical';
import IconRemove from '@cimpress-technology/react-streamline-icons/lib/IconRemove';
import IconSearch from '@cimpress-technology/react-streamline-icons/lib/IconSearch';

const containerStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  alignContent: 'space-around',
  alignItems: 'center',
  width: '20%',
});

const IconButton = () => {
  const onClick = () => console.log('Icon button clicked!');

  return (
    <FlexBox spaceBetween noGrow>
      <div className={containerStyle}>
        <Button size="sm" icon={<IconSearch />} onClick={onClick} />
        <Button icon={<IconSearch />} onClick={onClick} />
        <Button size="lg" icon={<IconSearch />} onClick={onClick} />
      </div>
      <div className={containerStyle}>
        <Button size="sm" variant="primary" icon={<IconRemove />} onClick={onClick} />
        <Button icon={<IconRemove />} variant="primary" onClick={onClick} />
        <Button icon={<IconRemove />} size="lg" variant="primary" onClick={onClick} />
      </div>
      <div className={containerStyle}>
        <Button size="sm" variant="link" icon={<IconNavigationMenuVertical />} onClick={onClick} />
        <Button icon={<IconNavigationMenuVertical />} variant="link" onClick={onClick} />
        <Button size="lg" variant="link" icon={<IconNavigationMenuVertical />} onClick={onClick} />
      </div>
      <div className={containerStyle}>
        <Button size="sm" variant="anchor" icon={<IconArrowButtonRight />} onClick={onClick} />
        <Button icon={<IconArrowButtonRight />} variant="anchor" onClick={onClick} />
        <Button size="lg" variant="anchor" icon={<IconArrowButtonRight />} onClick={onClick} />
      </div>
    </FlexBox>
  );
};

export default IconButton;
